import{d as e}from"./chunk.DQ7YBHX4.js";var o=class{constructor(t){(this.host=t).addController(this)}hostConnected(){let t=e(this.host);this.host.classList.add(`he-${t.getBaseName(this.host)}`)}};export{o as a};
